export default "__VITE_ASSET__c3d973b4__"